import Vue from "vue";
import App from "./App.vue";
import router from "./router/";
import store from "./store/";
import moment from 'moment';
import watch from './store/watch';

import {
	FETCH_MERCHANT,
	FETCH_RATES,
	FETCH_BADGE,
	GET_FINGERPRINT,
	GET_MERCHANT_CURRENCY,
	INITIALIZE_INVOICE,
	LOAD_INVOICE_DATA_CACHE
} from "@/store/actions.type";
import {
	CALL_END
} from "@/store/mutations.type";

// Language / Localization
import LanguageService from "@/common/language.service";

Vue.config.productionTip = false;

Vue.use(require('vue-moment'), {
    moment
})

import ApiService from "./common/api.service";
ApiService.init();

var load_app = function(){
	// We need to load in multiple places, so lets pull it out to a fn
	new Vue({
		router,
		store,
		render: h => h(App)
	}).$mount("#app");
	// Clear "pre-vue" loading screen manually, then clear App.vue loading screen in state
	$('.loading-screen').remove();
	store.commit(CALL_END);
}

// We ALWAYS need merchant information, start with that
Promise.all([
	store.dispatch(FETCH_MERCHANT)
]).then(() => {
	// Once we have merchant data, init app data
	store.dispatch(INITIALIZE_INVOICE);
	store.dispatch(LOAD_INVOICE_DATA_CACHE);

	// Load merchant currencies, badge & identify user
	Promise.all([
		store.dispatch(FETCH_RATES, { MerchantId: store.getters.merchant.MerchantId }),
		store.dispatch(FETCH_BADGE, { MerchantId: store.getters.merchant.MerchantId }),
		store.dispatch(GET_FINGERPRINT, { MerchantId: store.getters.merchant.MerchantId }),
		store.dispatch(GET_MERCHANT_CURRENCY, { Currency: store.getters.merchant.Currency })
	]).then(
		() => {
			// All required data is loaded => mount app
			load_app();
		},
		(error) => {
			// Handle any errors that arose from loading required data
			load_app();
			console.log(error);
			router.push({ name: 'Error', params: { error: error }});
		}
	);
}).catch(error => {
	// Load and throw error
	load_app();
	console.log(error);
	router.push({ name: 'Error', params: { error: LanguageService.getError('ClientNotFound') }});
});

// setup vuex watch
watch.init();
